import keycloakService from "../modules";
import React, { useEffect,useMemo } from "react";
import { Route, Routes,useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import setAuthToken from "../utils/setAuthToken";
import authActions from "../redux/auth/actions";
import LandingPages from '../pages/landingPage';
import { store } from '../redux/store';
import CandidateRoutes from "./candidateRoutes";
import { routeVerify } from "./routeVerify";

const AppRouter = React.memo(() => {
  const navigate = useNavigate();
  useEffect(() => {
    if (keycloakService.getIsAuthenticated()) {
      routeVerify()

      // setAuthToken(token);
      // store.dispatch({type:authActions.VERIFY_MOBILENO_FOR_SIGNUP,
      //   payload: { data: { emailid: localStorage.getItem('mhet_cnd_email'),
      //     dob:localStorage.getItem('mhcet_dob'),
      //     candidatename:localStorage.getItem('mhcet_name'), navigate: navigate } },})
      store.dispatch({type:authActions.GET_PROFILE_SUMMARY, payload: { navigate: navigate } });
      store.dispatch({type:authActions.GET_ALL_MENU});
    } else {
      localStorage.removeItem('mhet_cnd_token');
    }
  }, []);
const pathname = useMemo(() => {
  const project = localStorage.getItem('mhet_cnd_project');
  return project || 'mhcet';
}, []);

  return (
    <Routes>
      <Route path="/" element={<LandingPages />} />
      <Route
        path={`${pathname}/*`}
        element={<CandidateRoutes />}
      />
    </Routes>
  );
},[])

export default AppRouter;
